import "../../styles/global.scss";
import { Container, Row, Col, Form, Button, Alert, Card } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import happyKids from "../../images/carerchild.png";
import logo from "../../images/logo.png";
import styles from "../../styles/login.module.scss";
import axios from "axios";
import { serverUrl } from "../../helpers/utility";
import { AnimatePresence, motion } from "motion/react";
import { useState } from "react";
import { mutate } from "swr";

function Login() {
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    setError,
    clearErrors,
  } = useForm();
  let navigate = useNavigate();
  const [loginError, setLoginError] = useState(null);

  // WARN: When editing use the ngrok domain as localhost will be blocked!
  async function onSubmit(data) {
    try {
      if (data.emailAddress && data.password) {
        console.log(`Submitting login request...`);
        setLoginError(null);

        axios
          .post(
            `${serverUrl}/login`,
            {
              emailAddress: data.emailAddress,
              password: data.password,
            }
          )
          .then(async (response) => {
            // Persist to redux store, redirection then handled by componentDidUpdate (redux store update!)
            if (response && response.data && response.data.success) {
              const { user, token } = response.data.data;
              console.log(`--- User is: ${user?._id}`);

              localStorage.setItem("token", token);
              await mutate(`${serverUrl}/user`);
              await mutate(`${serverUrl}/location`);
            } else {
              console.info(`ERR: Could not login. ${JSON.stringify(response.data)}`);
              setLoginError(`Invalid username or password.`);
            }
          })
          .catch((error) => {
            console.error(`Unable to login, server error. ${JSON.stringify(error)}`);
            setLoginError(`Invalid username or password.`);
          });
      } else {
        console.error(`Invalid form, should be impossible with validation rules.`);
      }
    } catch (err) {
      console.error(`ERR: onSubmit error. ${err}`);
    }
  }

  return (
    <>
      <Container fluid className={`no-padding no-margin container-fluid`}>
        <Row>
          <Col
            lg={6}
            xl={7}
            className={styles.loginMarketing}
            style={{ backgroundImage: `url(${happyKids})` }}
          ></Col>

          <Col lg={6} xl={5} className={`${styles.loginArea}`}>
            {/* "handleSubmit" will validate your inputs before invoking "onSubmit" */}
            <form
              onSubmit={handleSubmit(onSubmit)}
              className={styles.loginForm}
              style={{
                // Important for not overlapping the button
                position: "relative",
                overflow: "hidden",
                marginBottom: 30,
              }}
            >
              <AnimatePresence mode="wait" initial={true}>
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  key={`step0`}
                  transition={{ duration: 0.3, delay: 0 }}
                >
                  <Card>
                    <Card.Body>
                      <div style={{ padding: "10px 15px" }}>
                        {/* <Row style={{ marginTop: 0, marginBottom: 15 }}>
                          <Col lg={12}>
                            <Alert
                              key={"organisation-not-approved"}
                              variant={`warning`}
                              className="text-center"
                            >
                              DEMO PURPOSES ONLY
                            </Alert>
                          </Col>
                        </Row> */}

                        <div
                          style={{ display: "flex", flexDirection: "row" }}
                          className="justify-content-center"
                        >
                          <img src={logo} style={{ height: 32, marginBottom: 10 }} />
                        </div>

                        <div style={{ display: "flex", flexDirection: "row", marginBottom: 3 }}>
                          <h3 className={`h3`}>Login</h3>
                        </div>

                        <div>
                          <label>Email address</label>
                          <input
                            {...register("emailAddress")}
                            className="form-control"
                            type="text"
                            placeholder={``}
                            required
                            autoFocus
                          />

                          <label>Password</label>
                          <input
                            {...register("password")}
                            type="password"
                            className="form-control mb-1"
                            placeholder={``}
                            required
                          />
                          <div className="mt-1">
                            <Link to={"/forgot-password"}>Forgot your password?</Link>
                          </div>
                        </div>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          padding: "0px 15px",
                        }}
                      >
                        {loginError ? (
                          <div className="error" style={{ marginBottom: 5 }}>
                            {loginError}
                          </div>
                        ) : null}

                        <input
                          className="form-control btn btn-primary"
                          type="submit"
                          value={`LOGIN`}
                        />

                        <div className={"margin-top-10"}>
                          <p>
                            Not registered yet? Sign up as a{" "}
                            <Link to={"/local-authority-sign-up"}>local authority</Link> or{" "}
                            <Link to={"/provider-sign-up"}>care provider</Link>.
                          </p>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </motion.div>
              </AnimatePresence>
            </form>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default Login;
